import { render, staticRenderFns } from "./finish.vue?vue&type=template&id=2f2e308a&scoped=true&"
import script from "./finish.vue?vue&type=script&lang=js&"
export * from "./finish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2e308a",
  null
  
)

export default component.exports